import script from "./PaymentTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentTable.vue?vue&type=script&setup=true&lang=js"

import "./PaymentTable.vue?vue&type=style&index=0&id=94fa1284&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94fa1284"]])

export default __exports__